<template>
  <div>
    <div class="banner">
        <h4>{{ title }}</h4>
    </div>

    <v-form @submit.prevent="create" ref="form">

      <v-text-field
        class="rounded-lg"
        color="#41916b"
        outlined
        v-model="resource.name"
        :rules="formRules"
        dense>
            <template v-slot:label>
                Descrição <span style="color: red;">*</span>
            </template>
      </v-text-field>

      <v-card-actions class="cardFooter">
          <v-spacer></v-spacer>
            <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
              <span>{{$t('buttons.cancel')}}</span>
            </v-btn>

            <v-btn class="rounded-lg" color="blue" text elevation="0" @click="$refs.form.reset()">
              <span>{{$t('buttons.clean_up')}}</span>
            </v-btn>

            <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
              <span class="textBtn">{{ btnMessage }}</span>
              <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
            </v-btn>
      </v-card-actions>
    </v-form>

  </div>
</template>

<script>
import { saveKinship } from "@/service/basic-registrations/KinshipService";
import Formatters from "@/utils/Formatters";
import { mapActions } from "vuex";
export default {
  data() {
    return {
        dialog: false,
        formRules: [(v) => !!v || "Campo obrigatório."],
        loading: false,
        options: {},
        sortBy: "name",
      };
  },

  props: {
      resource: {
        type: Object,
      }
    },

  computed: {
    title() {
      return this.resource.id ? 'Atualizar Parentesco' : 'Novo Parentesco';
    },

    btnMessage() {
      return this.resource.id ? 'Atualizar' : 'Salvar';
    }
  },

  watch: {
    'resource': {
        handler(item) {
            if (!item.id && this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
      immediate: true,
    }
  },

  methods: {
    ...mapActions([
      "changeSnackBarData",
    ]),

    create() {
      this.loading = true;
      if (this.$refs.form.validate()) {

        const dados = this.resource
              dados.name = this.resource.name;

            saveKinship(this.resource.id || null, dados).then((response) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
               this.closeDialog();
               this.closeSnackBar();
            }, 3000);
          }).catch((err) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            })
            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          });
      }
    },

    closeDialog() {
        this.$emit("closeDialog");
        this.$refs.form.resetValidation();
        this.$refs.form.reset();
        this.resource.name = "";
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    }

  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  margin-bottom: 20px;
}

.space {
  width: 15px;
}
.spacediferent {
  width: 7px;
}

.unity{
  font-size: 12px;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.0125em;
    font-family: 'Roboto';
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
